export const projects = [
    {
        "title": "Northern Hackers",
        "desc": "Multiplayer game where you have to cut down more trees than your friends",
        "image": "NorthernHackersBanner.png",

        "projectDesc": `In \"Northern Hackers\", you and a friend play as lumberjacks competing against each other to chop the most wood while avoiding angry, charging beavers.
        
        This was my first time creating a multiplayer game and using networking technologies. It was very challenging and the end result was admittedly buggy, but the game is still functional enough to be enjoyed.

        Made in 36 hours using Unity and C# for Hack the North 2020++`,

        "date": "2021",
        "icon": "fas fa-gamepad",
        "links": ["https://github.com/p-han-tom/NorthernHackers", "https://devpost.com/software/northernhackers"], 
        "linkIcons": ["fab fa-github", "fab fa-dev"]
    },
    {
        "title": "Blast to the Past",
        "desc": "Puzzle game with time travel mechanics",
        "image": "BlastToThePastBanner.png",
        "projectDesc": `Use your \“rewinder\” gun to rewind yourself or an enemy to a previous position in time, and beat 15 time-bending levels that will challenge your puzzle-solving skills.
        
        Fine-tuning the rewind mechanics and designing challenging puzzles were the hardest parts of this project, and they pushed my programming skills to their limits. In the end though, my teammate and I created a short but polished game that placed in the top tenth percentile of almost 2000 entries in the game jam. 

        Made in five days using Unity and C# for Brackeys Game Jam #4`,
        "date": "2020",
        "icon": "fas fa-gamepad",
        "links": ["https://github.com/p-han-tom/BrackeysGameJam4", "https://project-games.itch.io/blast-to-the-past"],
        "linkIcons": ["fab fa-github", "fab fa-itch-io"]
    },
    {
        "title": "Skelascent and Skelascent Mobile",
        "desc": "Endlessly scrolling platforming game",
        "image": "SkelascentBanner.png",
        "projectDesc": `Ascend an endless pit of flesh monsters to escape from the giant flesh wall (floor?) while throwing bones at enemies.
        
        Skelascent was the first game that I ever finished. Out of almost 120 entries, Skelascent placed 4th overall and 1st place in aesthetics in the game jam. This project was really my introduction to software development, and I learned a lot about project management, teamwork, and the importance of clear communication.

        Made in three days using Unity and C# for ScoreSpace Game Jam #9    
        `,

        "date": "2020",
        "icon": "fas fa-gamepad",
        "links": ["https://github.com/JerryLin1/SkelascentMobile", "https://bootleben.itch.io/skelascent"],
        "linkIcons": ["fab fa-github", "fab fa-itch-io"]
    },
    {
        "title": "This website",
        "desc": "The website you are on right now",
        "image": "PersonalWebsiteBanner.png",
        "projectDesc": `I am planning on frequently updating this website to help track my progress and advancement into the world of software engineering!
        
        Made using ReactJS and Material UI`,
        "date": "2021-present",
        "icon": "fas fa-globe",
        "links": ["https://github.com/p-han-tom/p-han-tom.github.io"],
        "linkIcons": ["fab fa-github"]

    }


]